import { createSelector } from '@ngrx/store';
import { BoelsState } from '../../reducers.index';
import * as fromFeature from '../../reducers.index';
import { ProductStockState } from '../reducers/product-stock.reducer';
import { BoelsPointOfServiceStock } from '@boels/models';

export const selectProductStockState = createSelector(
  fromFeature.getStoreState,
  (state: BoelsState) => state.productStock,
);

export const selectStockStores = createSelector(
  selectProductStockState,
  (state: ProductStockState) => state.stores as BoelsPointOfServiceStock[],
);

export const selectSelectedProductStock = createSelector(
  selectProductStockState,
  (state: ProductStockState) => state.selected,
);
